import { ModelBase } from "Core/Models";
import { action, observable } from "mobx";

export class ReservationType1FundingModel extends ModelBase<ReservationType1FundingModel, ReservationType1FundingDTO> {
    //#region Properties
    @observable
    public id: string | undefined = "";

    @observable
    public reservationId: string = "";

    @observable
    public mortgageRequired: boolean = false;

    @observable
    public isHelpToBuy: boolean = false;

    @observable
    public lenderName: string = "";

    @observable
    public lenderPersonName: string = "";

    @observable
    public lenderAddress1: string = "";

    @observable
    public lenderAddress2: string = "";

    @observable
    public lenderCity: string = "";

    @observable
    public lenderPostcode: string = "";

    @observable
    public lenderContactNumber: string = "";

    @observable
    public lenderFaxNumber: string = "";

    @observable
    public lenderEmail: string = "";

    @observable
    public financialAdvisorName: string = "";

    @observable
    public financialAdvisorPersonName: string = "";

    @observable
    public financialAdvisorAddress1: string = "";

    @observable
    public financialAdvisorAddress2: string = "";

    @observable
    public financialAdvisorCity: string = "";

    @observable
    public financialAdvisorPostcode: string = "";

    @observable
    public financialAdvisorContactNumber: string = "";

    @observable
    public financialAdvisorFaxNumber: string = "";

    @observable
    public financialAdvisorEmail: string = "";

    @observable
    public isCashBuyer: boolean = false;

    @observable
    public cashBuyerNotes: string = "";

    @observable
    public otherArrangements: string = "";

    @observable
    public isUsingHelpToBuyISA: boolean = false;

    @observable
    public isSectionComplete: boolean = false;

    @observable
    public completedDate: string = "";

    @observable
    public completedIdentityUserId: string = "";

    @observable
    public lenderFinancialId: string | null = null;

    @observable
    public financialAdvisorId: string | null = null;
    //#endregion

    @action
    public fromDto = (reservationDto: ReservationType1FundingDTO) => {
        this.id = reservationDto.id;
        this.reservationId = reservationDto.reservationId;
        this.mortgageRequired = reservationDto.mortgageRequired;
        this.isHelpToBuy = reservationDto.isHelpToBuy;
        this.lenderName = reservationDto.lenderName;
        this.lenderPersonName = reservationDto.lenderPersonName;
        this.lenderAddress1 = reservationDto.lenderAddress1;
        this.lenderAddress2 = reservationDto.lenderAddress2;
        this.lenderCity = reservationDto.lenderCity;
        this.lenderPostcode = reservationDto.lenderPostcode;
        this.lenderContactNumber = reservationDto.lenderContactNumber;
        this.lenderFaxNumber = reservationDto.lenderFaxNumber;
        this.lenderEmail = reservationDto.lenderEmail;
        this.financialAdvisorName = reservationDto.financialAdvisorName;
        this.financialAdvisorPersonName = reservationDto.financialAdvisorPersonName;
        this.financialAdvisorAddress1 = reservationDto.financialAdvisorAddress1;
        this.financialAdvisorAddress2 = reservationDto.financialAdvisorAddress2;
        this.financialAdvisorCity = reservationDto.financialAdvisorCity;
        this.financialAdvisorPostcode = reservationDto.financialAdvisorPostcode;
        this.financialAdvisorContactNumber = reservationDto.financialAdvisorContactNumber;
        this.financialAdvisorFaxNumber = reservationDto.financialAdvisorFaxNumber;
        this.financialAdvisorEmail = reservationDto.financialAdvisorEmail;
        this.isCashBuyer = reservationDto.isCashBuyer;
        this.cashBuyerNotes = reservationDto.cashBuyerNotes;
        this.otherArrangements = reservationDto.otherArrangements;
        this.isUsingHelpToBuyISA = reservationDto.isUsingHelpToBuyISA;
        this.isSectionComplete = reservationDto.isSectionComplete;
        this.completedDate = reservationDto.completedDate;
        this.completedIdentityUserId = reservationDto.completedIdentityUserId;
        this.lenderFinancialId = reservationDto.lenderFinancialId;
        this.financialAdvisorId = reservationDto.financialAdvisorId;
    };

    public toDto = (): ReservationType1FundingDTO => {
        return {
            id: this.id,
            reservationId: this.reservationId,
            mortgageRequired: this.mortgageRequired,
            isHelpToBuy: this.isHelpToBuy,
            lenderName: this.lenderName,
            lenderPersonName: this.lenderPersonName,
            lenderAddress1: this.lenderAddress1,
            lenderAddress2: this.lenderAddress2,
            lenderCity: this.lenderCity,
            lenderPostcode: this.lenderPostcode,
            lenderContactNumber: this.lenderContactNumber,
            lenderFaxNumber: this.lenderFaxNumber,
            lenderEmail: this.lenderEmail,
            financialAdvisorName: this.financialAdvisorName,
            financialAdvisorPersonName: this.financialAdvisorPersonName,
            financialAdvisorAddress1: this.financialAdvisorAddress1,
            financialAdvisorAddress2: this.financialAdvisorAddress2,
            financialAdvisorCity: this.financialAdvisorCity,
            financialAdvisorPostcode: this.financialAdvisorPostcode,
            financialAdvisorContactNumber: this.financialAdvisorContactNumber,
            financialAdvisorFaxNumber: this.financialAdvisorFaxNumber,
            financialAdvisorEmail: this.financialAdvisorEmail,
            isCashBuyer: this.isCashBuyer,
            cashBuyerNotes: this.cashBuyerNotes,
            otherArrangements: this.otherArrangements,
            isUsingHelpToBuyISA: this.isUsingHelpToBuyISA,
            isSectionComplete: this.isSectionComplete,
            completedDate: this.completedDate,
            completedIdentityUserId: this.completedIdentityUserId,
            lenderFinancialId: this.lenderFinancialId,
            financialAdvisorId: this.financialAdvisorId,
        };
    };
}

export interface ReservationType1FundingDTO {
    id: string | undefined;
    reservationId: string;
    mortgageRequired: boolean;
    isHelpToBuy: boolean;
    lenderName: string;
    lenderPersonName: string;
    lenderAddress1: string;
    lenderAddress2: string;
    lenderCity: string;
    lenderPostcode: string;
    lenderContactNumber: string;
    lenderFaxNumber: string;
    lenderEmail: string;
    financialAdvisorName: string;
    financialAdvisorPersonName: string;
    financialAdvisorAddress1: string;
    financialAdvisorAddress2: string;
    financialAdvisorCity: string;
    financialAdvisorPostcode: string;
    financialAdvisorContactNumber: string;
    financialAdvisorFaxNumber: string;
    financialAdvisorEmail: string;
    isCashBuyer: boolean;
    cashBuyerNotes: string;
    otherArrangements: string;
    isUsingHelpToBuyISA: boolean;
    isSectionComplete: boolean;
    completedDate: string;
    completedIdentityUserId: string;
    lenderFinancialId: string | null;
    financialAdvisorId: string | null;
}
